import React, { useEffect, useState } from "react";
import { Col, Row, Tabs, Typography, Tooltip, Popover, Button } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";

//locals from shared
import { PageContentLayout } from "../../../shared/layout";
import LocationTab from "./LocationTab";
import CreativeTab from "./CreativeTab";
import CreativeTable from "./CreativeTable";
import CreativeAdGroupTable from "./CreativeAdGroupTable";
import EmailTab from "./EmailTab";
import FiltersTab from "./FiltersTab";
import {
  FileImageOutlined,
  SettingOutlined,
  GlobalOutlined,
  LineChartOutlined,
  PictureOutlined,
  MailOutlined,
  VideoCameraOutlined,
  BulbOutlined,
  ReadOutlined,
  FundViewOutlined,
} from "@ant-design/icons";
import { determineUserAccess } from "../../../../core/permissions/userLevelAccess";
import TargetingLocationTab from "./Targeting/TargetingLocationTab";
import CreateAmplifyForm from "./CreateAmplifyForm";
import TrackingDetailsView from "../tabs/tracking/TrackingDetailsView";
import SettingDetailsView from "../tabs/setting/SettingDetailsView";
import VideoTab from "./VideoTab";
import VideoTable from "./VideoTable";
import AdVideosGroupTable from "./AdVideosGroupTable";
import AssistanceModeLayout from "../AssistanceModeLayout";

const { TabPane } = Tabs;
const { Paragraph } = Typography;

const OrgConfigDetails = ({
  currentuser,
  currentOrg,
  selectedOrg,
  onChange,
  updateOrg,
  parentState,
  changeLocationMap,
  locationList,
  onChangeOrg,
  onCsvUploadComplete,
  createLocation,
  createTargetingLocation,
  updateTargetingLocation,
  deleteLocation,
  editRetailLocation,
  resetParentState,
  updateOrgLocation,
  cartProvider,
  onChangeStateValue,
  orgMedias,
  createOrgMedia,
  updateOrgMedia,
  creativeName,
  onDeleteMedias,
  onLoadingDeleteMedias,
  onCreateAdgroup,
  adGroupCreatives,
  selectedLocations,
  onSubmitAudience,
  attributionAudienceName,
  onDeleteAdgroup,
  onLoadingDeleteAdGroup,
  selectedTab,
  google,
  isTargetingPreviewModalOpen,
  targetingLocationsPreviewData,
  closeTargetingPreviewModal,
  bulkImportTargetingLocations,
  selectTargetingLocationPreview,
  targetingAudiences,
  deleteAudienceLocation,
  deleteBulkLocation,
  handleSubmitRegionGroup,
  handleUpdateRegionGroup,
  deleteRegionGroup,
  regionGroups,
  handleSubmitIABCategoryGroup,
  iABCategoryGroups,
  deleteIABCategoryGroup,
  multipleTags,
  handleAmplifyCampaign,
  setDefaultAmplifyCreatives,
  setAudienceAmplifyDefault,
  currentAmplifyCampaign,
  handleUpdateAmplify,
  attributionAudiences,
  activateHashedEmailList,
  createHashedEmailList,
  updateHashedEmailList,
  deleteHashedEmailList,
  bulkCreateHashedEmailAddress,
  refetchHashedEmailLists,
  hashedEmailLists,
  bulkCreateOrgMedia,
  loadingHashedEmailList,
  orgId,
  updateAdGroup,
  dealIds,
  createDealId,
  deleteDealIds,
  updateDealId,
  onSwitchChange,
  onChangeDataConfigValue,
  presetRegionGroups,
  presetRegionGroupsLoading,
  orgVideoMedias,
  refetchVideoMedias,
  refetchMedias,
  processDeviceIds,
}) => {
  const style = {
    popover: {
      margin: "0",
      zIndex: 0,
    },
    bulbIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };
  const history = useHistory();

  const { permission, isPreviewOrg, defaultRole } = currentuser;

  const userPermission = determineUserAccess(permission);

  const { isSelfService, amplify } = userPermission;

  const [renewedCreatives, setRenewedCreatives] = useState([]);

  const [ids, setIds] = useState([]);
  const [videoCreativeIds, setVideoCreativeIds] = useState([]);
  const [videoCreativeKeys, setVideoCreativeKeys] = useState([]);

  const [creativeKeys, setCreativeKeys] = useState([]);
  const [enableAmplify, setEnableAmplify] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [currentTabOpen, setCurrentTabOpen] = useState(false);

  const [isAssistanceMode, setIsAssistanceMode] = useState(false);

  const sourcePermission = isPreviewOrg
    ? defaultRole.permission
    : userPermission;
  const isTrafficker = sourcePermission.isTrafficker || false;
  const configurator = sourcePermission.configurator || false;

  useEffect(() => {
    const filteredAudiences = targetingAudiences.filter(
      audience => audience.orgs && audience.orgs.length === 1
    );

    setEnableAmplify(
      filteredAudiences &&
        filteredAudiences.length &&
        adGroupCreatives &&
        adGroupCreatives.length &&
        multipleTags &&
        multipleTags.length
    );
  }, [targetingAudiences, adGroupCreatives, multipleTags]);

  const handleUpdateClickthroughUrl = clickthrough => {
    const adUnit = currentAmplifyCampaign.adUnits[0];
    handleUpdateAmplify({
      id: currentAmplifyCampaign.id,
      adUnitId: adUnit.id,
      clickthrough,
    });
  };

  const handleSearch = searchText => {
    setSearchText(searchText);
  };

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    let activeTab = "1";
    switch (tab) {
      case "location":
        activeTab = "1";
        break;
      case "targeting-location":
        activeTab = "2";
        break;
      case "creatives":
        activeTab = "3";
        break;
      case "tracking":
        activeTab = "4";
        break;
      case "email":
        activeTab = "5";
        break;
      case "settings":
        activeTab = "6";
        break;
      default:
        activeTab = "1";
        break;
    }

    setActiveTab(activeTab);
    setCurrentTabOpen(tab || "location");
  }, [location.search]);

  return (
    <>
      {isAssistanceMode && (
        <AssistanceModeLayout
          isAssistanceMode={isAssistanceMode}
          setIsAssistanceMode={setIsAssistanceMode}
        />
      )}
      <React.Fragment>
        {/* {isAssistanceMode && (
        <AssistanceModeLayout
          isAssistanceMode={isAssistanceMode}
          setIsAssistanceMode={setIsAssistanceMode}
        />
      )} */}
        <PageContentLayout>
          {amplify && !currentAmplifyCampaign ? (
            <CreateAmplifyForm
              handleAmplifyCampaign={handleAmplifyCampaign}
              enableAmplify={enableAmplify}
              currentAmplifyCampaign={currentAmplifyCampaign}
            />
          ) : null}

          {currentAmplifyCampaign ? (
            <>
              <Typography.Title
                level={3}
                style={{
                  margin: 0,
                }}
              >
                {currentAmplifyCampaign.name}
              </Typography.Title>
              <div>
                <Paragraph
                  editable={{
                    onChange: handleUpdateClickthroughUrl,
                  }}
                  style={{
                    marginLeft: 16,
                    marginTop: 8,
                  }}
                >
                  {currentAmplifyCampaign.adUnits[0].clickthrough}
                </Paragraph>
              </div>
            </>
          ) : null}

          {isSelfService || isPreviewOrg || amplify ? (
            <Row gutter={[18, 18]}>
              <Col xs={24} lg={24}>
                <Tabs
                  activeKey={activeTab}
                  onChange={activeKey => {
                    let currentTab = "1";
                    switch (activeKey) {
                      case "1":
                        currentTab = "location";
                        break;
                      case "2":
                        currentTab = "targeting-location";
                        break;
                      case "3":
                        currentTab = "creatives";
                        break;
                      case "4":
                        currentTab = "tracking";
                        break;
                      case "5":
                        currentTab = "email";
                        break;
                      case "6":
                        currentTab = "settings";
                        break;
                      case "7":
                        currentTab = "settings";
                        break;
                      default:
                        currentTab = "location";
                        break;
                    }
                    history.push(`/orgconfig?tab=${currentTab}`);
                    setCurrentTabOpen(currentTab);
                    setActiveTab(activeKey);
                    setIsAssistanceMode(false);
                  }}
                >
                  {isSelfService || isPreviewOrg ? (
                    <TabPane
                      tab={
                        <Tooltip title="The ability to target locations based on an address">
                          <span>
                            <GlobalOutlined />
                            Locations
                          </span>
                        </Tooltip>
                      }
                      key="1"
                    >
                      <LocationTab
                        locationList={locationList}
                        parentState={parentState}
                        changeLocationMap={changeLocationMap}
                        onChange={onChange}
                        onCsvUploadComplete={onCsvUploadComplete}
                        createLocation={createLocation}
                        deleteLocation={deleteLocation}
                        editRetailLocation={editRetailLocation}
                        resetParentState={resetParentState}
                        updateOrgLocation={updateOrgLocation}
                        cartProvider={cartProvider}
                        onChangeStateValue={onChangeStateValue}
                        selectedLocations={selectedLocations}
                        onSubmitAudience={onSubmitAudience}
                        attributionAudienceName={attributionAudienceName}
                        selectedOrgId={selectedOrg && selectedOrg.id}
                        attributionAudiences={attributionAudiences}
                        currentuser={currentuser}
                      />
                    </TabPane>
                  ) : null}
                  <TabPane
                    tab={
                      <Tooltip title="Targeting tool allows you to select specific locations, audiences, and region groups">
                        <span>
                          <GlobalOutlined />
                          Targeting
                        </span>
                      </Tooltip>
                    }
                    key="2"
                  >
                    <TargetingLocationTab
                      setAudienceAmplifyDefault={setAudienceAmplifyDefault}
                      attributionAudienceName={attributionAudienceName}
                      createTargetingLocation={createTargetingLocation}
                      deleteLocation={deleteLocation}
                      google={google}
                      locationList={locationList}
                      onChangeStateValue={onChangeStateValue}
                      onCsvUploadComplete={onCsvUploadComplete}
                      onSubmitAudience={onSubmitAudience}
                      selectedLocations={selectedLocations}
                      updateTargetingLocation={updateTargetingLocation}
                      isTargetingPreviewModalOpen={isTargetingPreviewModalOpen}
                      targetingLocationsPreviewData={
                        targetingLocationsPreviewData
                      }
                      closeTargetingPreviewModal={closeTargetingPreviewModal}
                      bulkImportTargetingLocations={
                        bulkImportTargetingLocations
                      }
                      selectTargetingLocationPreview={
                        selectTargetingLocationPreview
                      }
                      targetingAudiences={targetingAudiences}
                      deleteAudienceLocation={deleteAudienceLocation}
                      deleteBulkLocation={deleteBulkLocation}
                      handleSubmitRegionGroup={handleSubmitRegionGroup}
                      handleUpdateRegionGroup={handleUpdateRegionGroup}
                      deleteRegionGroup={deleteRegionGroup}
                      regionGroups={regionGroups}
                      handleSubmitIABCategoryGroup={
                        handleSubmitIABCategoryGroup
                      }
                      iABCategoryGroups={iABCategoryGroups}
                      deleteIABCategoryGroup={deleteIABCategoryGroup}
                      selectedOrg={selectedOrg}
                      isSelfService={isSelfService}
                      isPreviewOrg={isPreviewOrg}
                      amplify={amplify}
                      dealIds={dealIds}
                      createDealId={createDealId}
                      deleteDealIds={deleteDealIds}
                      updateDealId={updateDealId}
                      presetRegionGroups={presetRegionGroups}
                      presetRegionGroupsLoading={presetRegionGroupsLoading}
                    />
                  </TabPane>
                  <TabPane
                    tab={
                      <Tooltip title="The Creatives section of our tool allows you to easily manage all of your ad content. You can delete existing creatives, bulk upload new ones, create an ad group, and download your creatives for use outside of the platform.">
                        <span>
                          <PictureOutlined />
                          Creatives
                        </span>
                      </Tooltip>
                    }
                    key="3"
                  >
                    <Tabs type="card" defaultActiveKey="a">
                      <TabPane
                        tab={
                          <span>
                            <FileImageOutlined />
                            Creatives
                          </span>
                        }
                        key="a"
                      >
                        <FiltersTab
                          searchText={searchText}
                          onSearch={handleSearch}
                        />
                        <CreativeTab
                          onChangeStateValue={onChangeStateValue}
                          createOrgMedia={createOrgMedia}
                          creativeName={creativeName}
                          onDeleteMedias={onDeleteMedias}
                          onLoadingDeleteMedias={onLoadingDeleteMedias}
                          ids={ids}
                          onCreateAdgroup={onCreateAdgroup}
                          setIds={setIds}
                          setRenewedCreatives={setRenewedCreatives}
                          orgMedias={orgMedias}
                          creativeKeys={creativeKeys}
                          bulkCreateOrgMedia={bulkCreateOrgMedia}
                          refetchMedias={refetchMedias}
                          renewedCreatives={renewedCreatives}
                        />
                        <CreativeTable
                          orgMedias={renewedCreatives}
                          setIds={setIds}
                          setCreativeKeys={setCreativeKeys}
                          updateOrgMedia={updateOrgMedia}
                          searchText={searchText}
                        />
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <FileImageOutlined />
                            Ad Groups
                          </span>
                        }
                        key="b"
                      >
                        <CreativeAdGroupTable
                          setDefaultAmplifyCreatives={
                            setDefaultAmplifyCreatives
                          }
                          adGroupCreatives={adGroupCreatives}
                          onDeleteAdgroup={onDeleteAdgroup}
                          onLoadingDeleteAdGroup={onLoadingDeleteAdGroup}
                          amplify={amplify}
                          selectedOrg={selectedOrg}
                          updateAdGroup={updateAdGroup}
                          orgMedias={renewedCreatives}
                          setIds={setIds}
                          setCreativeKeys={setCreativeKeys}
                        />
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <VideoCameraOutlined />
                            Videos
                          </span>
                        }
                        key="videoTab"
                      >
                        <VideoTab
                          createOrgMedia={createOrgMedia}
                          videoCreativeIds={videoCreativeIds}
                          videoCreativeKeys={videoCreativeKeys}
                          setVideoCreativeIds={setVideoCreativeIds}
                          setVideoCreativeKeys={setVideoCreativeKeys}
                          onChangeStateValue={onChangeStateValue}
                          onCreateAdgroup={onCreateAdgroup}
                          onDeleteMedias={onDeleteMedias}
                          refetchMedias={refetchMedias}
                          refetchVideoMedias={refetchVideoMedias}
                        />
                        <VideoTable
                          orgMedias={orgVideoMedias}
                          setVideoCreativeIds={setVideoCreativeIds}
                          setVideoCreativeKeys={setVideoCreativeKeys}
                          updateOrgMedia={updateOrgMedia}
                          refetchVideoMedias={refetchVideoMedias}
                        ></VideoTable>
                      </TabPane>
                      <TabPane
                        tab={
                          <span>
                            <VideoCameraOutlined />
                            Ad Video Groups
                          </span>
                        }
                        key="adVideoTab"
                      >
                        <AdVideosGroupTable
                          amplify={amplify}
                          selectedOrg={selectedOrg}
                          adVideosGroups={adGroupCreatives}
                          onDeleteAdgroup={onDeleteAdgroup}
                        />
                      </TabPane>
                    </Tabs>
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <span style={{ display: "block" }}>
                          <Popover
                            content={
                              <div>
                                <div>
                                  <Button
                                    type="link"
                                    style={style.popover}
                                    icon={<VideoCameraOutlined />}
                                  >
                                    Watch Video (Coming Soon)
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    type="link"
                                    style={style.popover}
                                    icon={<ReadOutlined />}
                                    onClick={() =>
                                      window.open(
                                        "https://coda.io/d/MediaJel-Dashboard-User-Guide_dU5_z3S7V8O/Setup-Tag-Pixel-Tracker_suRkc#_luEtJ",
                                        "_blank"
                                      )
                                    }
                                  >
                                    Read Documentation
                                  </Button>
                                </div>
                                <div>
                                  <Button
                                    type="link"
                                    style={style.popover}
                                    icon={<FundViewOutlined />}
                                    onClick={() => setIsAssistanceMode(true)}
                                  >
                                    View Slideshow
                                  </Button>
                                </div>
                              </div>
                            }
                            trigger="click"
                            overlayStyle={{ padding: 0 }}
                            // visible={currentTab === 'tracking'}
                          >
                            <div
                              style={{
                                ...style.bulbIcon,
                                position: "absolute",
                                top: "5%",
                                left: "50%",
                                display:
                                  currentTabOpen === "tracking"
                                    ? "flex"
                                    : "none",
                                alignItems: "center",
                              }}
                            >
                              <BulbOutlined />
                            </div>
                          </Popover>
                        </span>
                        <span style={{ verticalAlign: "middle" }}>
                          <Tooltip
                            title={
                              "Simply enter a name and select your cart provider from the dropdown menu. Once the tag is created, you can click into it to test and make sure it's working properly. This feature provides you all the tracking you need to optimize and measure the performance of your campaigns."
                            }
                          >
                            <span>
                              <LineChartOutlined />
                              Tracking
                            </span>
                          </Tooltip>
                        </span>
                      </span>
                    }
                    key="4"
                  >
                    <TrackingDetailsView
                      orgId={orgId}
                      cartProvider={cartProvider}
                      amplify={amplify}
                      isTrafficker={isTrafficker}
                      isAssistanceMode={isAssistanceMode}
                      setIsAssistanceMode={setIsAssistanceMode}
                    />
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <MailOutlined />
                        First Party Data
                      </span>
                    }
                    key="5"
                  >
                    <EmailTab
                      activateHashedEmailList={activateHashedEmailList}
                      createHashedEmailList={createHashedEmailList}
                      updateHashedEmailList={updateHashedEmailList}
                      bulkCreateHashedEmailAddress={
                        bulkCreateHashedEmailAddress
                      }
                      hashedEmailLists={
                        !isEmpty(hashedEmailLists) ? hashedEmailLists : []
                      }
                      deleteHashedEmailList={deleteHashedEmailList}
                      refetchHashedEmailLists={refetchHashedEmailLists}
                      loadingHashedEmailList={loadingHashedEmailList}
                      processDeviceIds={processDeviceIds}
                    />
                  </TabPane>

                  {isSelfService || isPreviewOrg || configurator ? (
                    <TabPane
                      tab={
                        <Tooltip
                          title={`Edit Profile: Allows you to update your personal information and adjust the color scheme 
                      of your organization's primary and sidebar. Additionally, 
                      you can add data configuration settings to tailor the way data is displayed and analyzed`}
                        >
                          <span>
                            <SettingOutlined />
                            Settings
                          </span>
                        </Tooltip>
                      }
                      key="6"
                    >
                      <SettingDetailsView selectedOrg={selectedOrg} />
                    </TabPane>
                  ) : null}
                </Tabs>
              </Col>
            </Row>
          ) : null}
        </PageContentLayout>
      </React.Fragment>
    </>
  );
};

export default OrgConfigDetails;
